export default "__VITE_ASSET__hFtegvdn__"